import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  private translate = inject(TranslateService);
  private title = inject(Title);
  private titleSubscription?: Subscription;

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);

    this.titleSubscription?.unsubscribe();

    if (pageTitle) {
      this.titleSubscription = this.translate
        .stream(pageTitle)
        .subscribe((translatedTitle: string) => {
          this.title.setTitle(`SIAE | ${translatedTitle}`);
        });
    } else {
      this.title.setTitle('SIAE');
    }
  }
}


